import React, { Component } from 'react';
import { withFirebase } from '../../../utils/Firebase';

// import ReactFilestack from 'filestack-react';

import FileUploader from "react-firebase-file-uploader";
import { Line } from 'rc-progress';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash
} from '@fortawesome/free-solid-svg-icons'

import './FileList.scss';
import Loading from '../../atoms/Loading';
class Uploadfile extends Component {

  _initFirebase = false;

  state = {
    savedFiles:[],
    loading: true,
    filenames: [],
    downloadURLs: [],
    isUploading: false,
    uploadProgress: 0
  };

  firebaseInit = () => {
    if (this.props.firebase && !this._initFirebase) {
      this._initFirebase = true;

      this.getFiles();
    }
  };

  componentDidMount() {
    this.firebaseInit();
  }

  componentDidUpdate() {
    this.firebaseInit();
  }

  getFiles = () => {
    const { firebase } = this.props;

    var uid;
    if(firebase && firebase.currentUser()){
      uid = firebase.currentUser().uid;
    }

    firebase
    .filesByUser(uid)
      .get()
      .then(querySnapshot => {
        const data = querySnapshot.docs.map(item => item.data());
        this.setState({
          savedFiles: data,
          loading: false,
        });
      });

  };

  removeFile = (id) => {
    const { firebase } = this.props;
    alert("are you sure you want to delete " + id);

    // // delete files
    // var desertRef = onboardStorage.child('images/desert.jpg');

    // // Delete the file
    // desertRef.delete().then(function() {
    //   // File deleted successfully
    // }).catch(function(error) {
    //   // Uh-oh, an error occurred!
    // });
    firebase.files().doc(id).delete();

    this.getFiles();
  }

  handleUploadStart = () =>
    this.setState({
      isUploading: true,
      uploadProgress: 0
    });

  handleProgress = progress =>
    this.setState({
      uploadProgress: progress
    });

  handleUploadError = error => {
    this.setState({
      isUploading: false
    });
  };

  handleUploadSuccess = async filename => {
    const { firebase } = this.props;

    // create upload path
    var uploadpath, uid;
    if(firebase && firebase.currentUser()){
      uid = firebase.currentUser().uid;
      uploadpath =  uid + '/files';
    }

    const downloadURL = await firebase
      .onboardStorage()
      .ref(uploadpath)
      .child(filename)
      .getDownloadURL();
    
      // update state
    this.setState(oldState => ({
      filenames: [...oldState.filenames, filename],
      downloadURLs: [...oldState.downloadURLs, downloadURL],
      uploadProgress: 100,
      isUploading: false
    }));

    // save to DB
    const latestFile = {
      "uid": uid,
      "filename":filename,
      "uploadpath":uploadpath,
      "downloadURL":downloadURL,
      "timestamp": new Date().getTime()
    };
    firebase.files().add({
      ...latestFile,
    });

    this.getFiles()
  };

  handleDrop = (files, event) => {
  }

  render() {
    const { loading, firebase, isLoaded } = this.props;

    const { savedFiles } = this.state;
    // const { savedFiles } = this.state;

    if(!firebase) return <Loading />;


    if (!isLoaded && loading) return <Loading />;
    var uploadpath;

    if(firebase && firebase.currentUser()){
      uploadpath = firebase.currentUser().uid + '/files';
    }

    return (
      <div className="container">
        <h1>Upload Assets</h1>
        <p>Upload your Ad Creative's and any brand Assets</p>
        <FileUploader
          accept="image/*"
          name="image-uploader-multiple"
          randomizeFilename
          storageRef={firebase.onboardStorage().ref(uploadpath) }
          onUploadStart={this.handleUploadStart}
          onUploadError={this.handleUploadError}
          onUploadSuccess={this.handleUploadSuccess}
          onProgress={this.handleProgress}
          multiple
        />

        {this.state.uploadProgress ? (
          <Line percent={this.state.uploadProgress} trailWidth="1" strokeWidth="1" strokeColor="#4ab5eb" />
        ) : (
          ''
        )}

<br/><br/>
      
        <div className="fileList card">
          <div className="fileList__header">
            <div className="fileList__header_item">uid</div>
            <div className="fileList__header_item">filename</div>
          </div>
          <div className="fileList__content">
          {savedFiles &&
            savedFiles.length > 0 &&
            savedFiles.map((item, id) => (
                <div key={id} className="fileList__content_item">
                  <div className="thumbnail">
                    { (item.downloadURL ? <img src={item.downloadURL}/> : '') }
                  </div>
                  <p>{item.uid }</p>
                  <p>{item.filename }</p>
                  <div className="fileList__content_item_delete" onClick={ () => this.removeFile(item.uid) }>
                    <FontAwesomeIcon icon={faTrash} />
                  </div>
                </div>
          ))}
          </div>
        </div>

        <hr />
        <h3>Or use this tool:</h3>
        {/* <ReactFilestack
          apikey={"Am4TJxIyAQMqav8ic4hgjz"}
          onSuccess={(res) => console.log(res)}
        /> */}
      </div>
    );
  }
}

export default withFirebase(Uploadfile);
